const kr = {
  100000001:'핵심 정보',
  100000002:'토큰 이름',
  100000003:'복사본 생성자',
  100000004:'복제 생성 시간',
  100000005:'기초 정보',
  100000006:'소속 퍼블릭 체인/프로토콜',
  100000007:'스마트 계약 주소',
  100000008:'발행 시간',
  100000009:'발행 총량',
  100000010:'유통 총량',
  100000011:'시가',
  100000012:'소개',
  100000013:'소셜 미디어 정보',
  100000014:'포털사이트',
  100000015:'백지',
  100000016:'블록체인 탐색기',
  100000017:'프로젝트 점수',
  100000018:'순위',
  100000019:'상위',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'업데이트 시간',
  100000027:'보안 점수',
  100000028:'스마트 계약 보안 점수',
  100000029:'위험 프로젝트 통계',
  100000030:'계약 코드 세부사항',
  100000031:'구매 세금',
  100000032:'판매 세금',
  100000033:'허니팟 여부',
  100000034:'재발행 가능 여부',
  100000035:'블랙리스트가 있습니까',
  100000036:'화이트리스트가 있습니까',
  100000037:'반고래 여부',
  100000038:'세율 변경 가능 여부',
  100000039:'오픈 소스 여부',
  100000040:'숨겨진 보유자 여부',
  100000041:'자가 파괴 가능 여부',
  100000042:'프록시 계약 여부',
  100000043:'잔액을 변경할 수 있습니까 ',
  100000044:'외부 호출을 실행할 수 있습니까',
  100000045:'소유권을 다시 획득할 수 있습니까',
  100000046:'거래 냉각 기간이 있습니까',
  100000047:'송금을 일시 중지할 수 있습니까',
  100000048:'소유권이 포기되지 않음',
  100000049:'조정 가능한 반고래입니까',
  100000050:'소수 자릿수가 너무 많음',
  100000051:'공개된 민트와 번(mint and burn) 방법',
  100000052:'토큰 소각이 총량을 업데이트합니까',
  100000053:'토큰 소각이 잔액을 업데이트합니까',
  100000054:'자전거래가 잔액을 증가시킵니까',
  100000055:'잔액보다 많은 토큰 전송이 무효화됩니까',
  100000056:'잔액이 전송 중에 업데이트되지 않음',
  100000057:'수신자의 잔액이 소모됩니까',
  100000058:'TransferFrom 호출이 잔액을 초과할 때 실패하나요',
  100000059:'BurnFrom 메서드는 총량을 업데이트하나요',
  100000060:'토큰의 구매 세금을 감지합니다. 5% 이상이면 높은 세율로 간주됩니다.',
  100000061:'토큰의 판매 세금을 감지합니다. 5% 이상이면 높은 세율로 간주됩니다.',
  100000062:'토큰이 허니팟 사기인지 확인합니다.',
  100000063:'더 많은 토큰을 발행할 수 있는지 확인합니다.',
  100000064:'사용자가 토큰 스왑 또는 전송을 제한할 수 있는 블랙리스트가 있는지 확인합니다.',
  100000065:'어떤 제한도 우회할 수 있는 주소를 허용하는 화이트리스트가 있는지 확인합니다.',
  100000066:'토큰에 반-고래 메커니즘이 있는지 확인합니다.',
  100000067:'토큰에 세금이 있으며, 세금이 특권 있는 역할에 의해 수정될 수 있는지 확인합니다.',
  100000068:'토큰이 블록체인 탐색기에 검증되었는지 확인합니다.',
  100000069:'소유권이 포기된 것처럼 보이더라도 계약을 조작할 수 있는 숨겨진 소유자가 있는지 확인합니다.',
  100000070:'토큰이 자가-파괴할 수 있는지 확인합니다.',
  100000071:'토큰이 함수 호출을 구현 계약으로 위임하는 프록시 계약인지 확인합니다.',
  100000072:'특권 있는 역할에 의해 토큰 잔액이 수정될 수 있는지 확인합니다.',
  100000073:'토큰이 외부 계약을 호출하는지 확인합니다.',
  100000074:'소유권을 다시 얻기 위한 백도어가 있는지 확인합니다.',
  100000075:'토큰에 전송 쿨다운 메커니즘이 있는지 확인합니다.',
  100000076:'특권 있는 역할에 의해 토큰 거래가 일시 정지될 수 있는지 확인합니다.',
  100000077:'소유권 권한이 포기되었는지 확인합니다.',
  100000078:'토큰의 반-고래 메커니즘이 특권 있는 역할에 의해 수정될 수 있는지 확인합니다.',
  100000079:'decimals() 함수의 반환값이 5 이상인지 확인합니다.',
  100000080:'임의의 사용자가 mint() 및 burn() 함수를 호출할 때 되돌려지는지 확인합니다.',
  100000081:'burn() 함수를 호출할 때 totalSupply가 올바르게 업데이트되는지 확인합니다.',
  100000082:"burnFrom() 함수를 호출할 때 허용량이 올바르게 업데이트되는지 확인합니다.",
  100000083:'수신자가 거래 발신자와 동일한 경우 transfer() 함수를 호출할 때 발신자의 잔액이 증가하는지 확인합니다.',
  100000084:'잔액보다 많은 금액으로 transfer() 함수를 호출할 때 실패하는지 확인합니다.',
  100000085:"transferFrom() 함수를 호출한 후 지출자의 허용량이 적절히 업데이트되는지 확인합니다.",
  100000086:"transferFrom() 함수를 호출할 때 지출자의 잔액을 사용하는지 확인합니다.",
  100000087:"transferFrom()을 호출한 후 허용량이 올바르게 업데이트되는지, 또는 금액이 유효하지 않을 경우 트랜잭션이 되돌려지는지 확인하세요.",
  100000088:"burnFrom() 함수를 호출할 때 totalSupply가 올바르게 업데이트되는지 확인하세요.",
  100000089:'발행 권한이 존재하는지 확인합니다.',
  100000090:'동결 권한이 존재하는지 확인합니다.',
  100000091:'메타데이터를 변경할 수 있는지 검토합니다.',
  100000092:'위급',
  100000093:'주요',
  100000094:'중간',
  100000095:'사소한',
  100000096:'정보',
  100000097:'Mint 권한이 포기되었나요',
  100000098:'동결 권한이 포기되었나요',
  100000099:'토큰의 메타데이터를 변경할 수 있나요',

  100000100:'당신의 연간 보고서가 생성되고 있습니다…',
  100000101:'환영합니다',
  100000102:'귀하의 2024년 리뷰',
  100000103:'나는 당신의 개인 가이드입니다',
  100000104:'2024년의 발자취를 함께 돌아보겠습니다.',
  100000105:'보고서 열기',
  100000106:'{num} 일 전, 운명의 톱니바퀴가 움직이기 시작했습니다.',
  100000107:'{userName} 우리의 이야기는 여기서부터 시작됩니다',
  100000108:'함께한 꿈을 위해 우리는 달려왔습니다',
  100000109:'투자 수익 스타',
  100000110:'연간 개요 월렛 누적 수익률',
  100000111:'당신은 <em class="normal bold" style="color: #2AFF0A;">{percentage}</em> 의 사용자보다 앞서 있습니다',
  100000112:'지난 1년 동안, 새겨진 것들이 가져온 <em class="normal bold" style="color: #FFF;">FOMO</em>를 경험했고, <em class="normal bold" style="color: #FFF;">meme 폭등</em> 의 기쁨을 누렸습니다. 이제, 당신의 기억으로 함께 들어가 봅시다.',
  100000113:'에이스 트레이더',
  100000114:'2024년도 누적 거래(회)',
  100000115:'누적 거래 금액($)',
  100000116:'당신은 사용자 <em class="normal bold" style="color: #FFC72B;">{percentage}%</em> 를 초과했습니다.',
  100000117:'이것은 단순한 숫자의 축적이 아닌, 당신의 통찰력과 지혜의 훈장입니다.',
  100000118:'모든 거래는 Web3.0으로 나아가는 원동력이 됩니다.',
  100000119:'잠재력 신성',
  100000120:'Bitcoin은 2024년에 최대<em class="normal">34%</em>하락하며 시장 조정이 일상이 되었습니다. 당신의 투자 성과는 하나의 단계적 결과일 뿐, 미래는 여전히 가능성으로 가득합니다!',
  100000121:'안정적인 투자자',
  100000122:'모든 관찰과 기다림은 더 정확한 시기를 맞이하기 위한 준비입니다. 2025년에는 당신만의 투자와 수익의 기적을 기대합니다!',
  100000123:'2024년 당신이 가장 많이 거래한 토큰',
  100000124:'간절히 바란다면 반드시 이룰 수 있습니다.',
  100000125:'집중과 노력은 거래 결과에서 빛을 발하고 있습니다.',
  100000126:'2024년 Bitcoin의 SuperEx 상승 및 하락 폭',
  100000127:'2024년 당신의 Bitcoin 변동률',
  100000128:'당신의 자산은 성장했습니다! 내년에도 힘내시길 바랍니다.',
  100000129:'2024년에 아직 Bitcoin을 보유하지 않았습니다',
  100000130:'탁월한 투자자',
  100000131:'안정적인 투자자',
  100000132:'학습형 투자자',
  100000133:'당신의 현물 메인보드 거래 데이터',
  100000134:'누적 수익($)',
  100000135:'연간 수익률(%)',
  100000136:'수익 리드(%)',
  100000137:'당신의 계약 거래 데이터',
  100000138:'당신의 투자 전략은 지혜로 가득합니다. 함께 해 주셔서 감사합니다!',
  100000139:'새로운 출발',
  100000140:'당신은 트렌드를 따르는 것뿐만 아니라, 트렌드의 선두주자입니다! 당신은 자유 구역에서 코인을 <em class="normal bold" style="color: #FFF;">{num1}</em> 회 발행하고, <em class="normal bold" style="color: #FFF;">{num2}</em> 회 거래했습니다. 혁신적인 제품을 좋아하는 당신은 진정한 모험가입니다!',
  100000141:'슈퍼 소셜 마스터',
  100000142:'감사합니다! 당신 덕분에 저희에게 새로운 얼굴 <em class="normal bold" style="color: #FFF;">{num}</em> 명이 찾아왔습니다. 플랫폼은 당신의 추천으로 더욱 번영하였으며, Web3.0으로 향하는 길에더 많은 뜻이 맞는 동료들을 기대합니다.',
  100000143:'소셜 잠재력 신성',
  100000144:'SuperEx에는 총 <em class="normal bold" style="color: #FFF;">{num}</em> 명의 사용자가 친구 초대를 통해 최대 40% 거래 수수료를 벌고 있습니다. 2024년을 놓치셨더라도 괜찮습니다. 2025년에는 반드시 이 기회를 잡으세요!',
  100000145:'당신의 연간 하이라이트를 공유하세요! 커뮤니티에 공유하여 더 많은 사람들이 함께할 수 있도록 격려하세요. 함께 특별한 보상을 잠금 해제하고, 암호화폐 세계를 탐험합시다!',
  100000146:'친구를 초대하여 10 USDT 상당의 보상을 받으세요!',
  100000147:'리포트 공유',
  100000148:'다시 보기',
  100000149:'2024년, SuperEx에서 당신은 이렇게 불렸습니다',
  100000150:'플랫폼 사용자들을 이미 초과했습니다:',
  100000151:'현물 메인 보드 연간 수익률:',
  100000152:'계약 연간 수익률',
  100000153:'올해, 나는 투자 전설이다!',
  100000154:'초대 코드: {InviteCode}',
  100000155:'SuperEx.com - web3.0 암호화폐 거래소',
  100000156:'안정 속에서 승리하고, 실력으로 빛나다!',
  100000157:'올해는 경험을 쌓았고, 내년에는 더 빛날 것입니다!',
  100000158:'알고 계셨나요?',
  100000159:'SuperEx의 현물 자유 구역은 세계에서 가장 인기 있고 잠재력이 있는 Meme 코인 거래 플랫폼입니다.',
  100000160:'2024, SuperEx에 새로운 <em class="normal bold" style="color: #FFF;">{num}</em> 사용자가 추가됩니다, 새로운 가족으로서',
  100000161:'당신만의 2024 회고와 2025 천배 수익 여행이 곧 시작됩니다.',
  100000162:'이것은 Superex의 오랜 가족이 보낸 편지로, 그 안에는 2024년의 기쁜 소식이 기록되어 있습니다.',
  100000163:'@To***는 1USDT로 1 BTC를 성공적으로 구매했으며, 수익률은 <em class="normal bold" style="color: #FFF;font-size:0.7rem">9,958,800%</em> 입니다.',
  100000164:'이용자 @1o***는 1USDT로 1ETH를 얻었으며, 수익률은 <em class="normal bold" style="color: #FFF;font-size:0.7rem">487,000%</em> 에 달합니다.',
  100000165:'@we***1USDT로 아이폰15 1대 획득, 수익률 <em class="normal bold" style="color: #FFF;font-size:0.7rem">92,800%</em> 에 달함.',
  100000166:'더 많은 흥미로운 내용이 있습니다…',
  100000167:'소자본, 대수익, 끊임없이 업그레이드되는 방법으로 매 참여가 항상 놀라움으로 가득합니다!',
  100000168:'현물, 계약, 자산 관리…',
  100000169:'집편지가 길니 계속 읽어보자',
  100000170:'누적 최초 발행 토큰 <span class="inline-block relative bold" style="color: #FFFFFF;font-size:1rem">150+</span>개 이상, SuperEx는 사용자에게 더 많은 기회를 제공하기 위해 계속 노력할 것입니다.',
  100000171:'연간 지갑 개요 계좌 누적 수익률',
  100000172:'지갑 개요 계좌 연간 손익 금액 <em class="normal bold {classNum}">{num}</em>',
  100000173:'당신은 <em class="normal bold" style="color: #FFF;font-size:1rem">{percentage}%</em> 의 사용자보다 앞서 있습니다. 투자 전략에 대한 당신의 지혜는 놀랍습니다.',
  100000174:'2025-SuperEx',
  100000175:'부의 길',
  100000176:'열다 기다려',
  100000177:'안녕하세요! 저는 SuperEx의 새로운 친구입니다.',
  100000178:'SuperEx에 가입하고 무한한 가능성을 탐험하십시오. 등록 시 신규 사용자 혜택을 즐기십시오.',
  100000179:'사용자@vb***가 현물 기본 거래소에서 $ATOM에 대한 누적 수익률이 거의 <em class="normal bold" style="color: #FFF;font-size:0.7rem">10,400%</em> 입니다.',
  100000180:'사용자@xi***현물 메인보드에서 거래 $PIPE의 누적 수익률이 거의 <em class="normal bold" style="color: #FFF;font-size:0.7rem">7,400%</em> 에 달함',
  100000181:'사용자@09***가 현물 정산 거래 $ATH의 누적 수익률이 <em class="normal bold" style="color: #FFF;font-size:0.7rem">3,500%</em> 에 근접합니다.',
  100000182:'우리는 WEB3 세계의 거래소에서 당신의 첫 거래를 목격하고 멋진 장을 열기를 기대합니다!',
  100000183:'1USD, Super Start, 1000+ 현물, 150X 레버리지, 1000X 비문...',
  100000184:'다양한 고수익 섹터를 경험해 보세요!',
  100000185:'상승과 하락은 오고 가지만, 신념은 영원하다',
  100000186:'변동을 넘어 가치를 증명하다',
  100000187:'2024년 연간 보고서는 아직 생성되지 않았습니다. 새로운 한 해의 거래 여정을 시작하고, 더 많은 상호작용을 쌓아 다음 해의 맞춤형 요약을 해제하세요!',
  100000188:'2024년 암호화폐 연간 스토리가 여러분의 검토를 기다리고 있습니다! SuperEx로 2024년의 하이라이트 순간을 재현하고, 와서 특별한 순간을 공유하세요! ',
  100000189:'2024년 암호화폐 연간 스토리가 여러분의 검토를 기다리고 있습니다!',
  100000190: 'SuperEx 앱을 열어 "연간 보고서"를 확인하세요',
  100000191: '{year}년 {month}월 {day}일 (UTC)',
  100000192: '',
  100000193: '',
  100000193: '',
}
export default kr


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/kr.js